import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import AgentMetricsOverview from './components/AgentMetricsOverview';
import AgentPerformanceTable from './components/AgentPerformanceTable';
import RiskContributionPanel from './components/RiskContributionPanel';
import PerformanceInsights from './components/PerformanceInsights';
import AllAgentsList from './components/AllAgentsList';
import AgentDetailModal from './components/AgentDetailModal';

const AgentPerformanceAnalytics = () => {
  const navigate = useNavigate();
  const [user] = useState({
    id: 'admin-001',
    name: 'Sarah Johnson',
    email: 'sarah.johnson@moneytransfer.com',
    role: 'admin'
  });

  const [selectedTimeRange, setSelectedTimeRange] = useState('7d');
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  const handleLogout = () => {
    navigate('/login');
  };

  const handleAgentSelect = (agent) => {
    setSelectedAgent(agent);
  };

  const handleAgentClick = (agent) => {
    setSelectedAgent(agent);
    setIsDetailModalOpen(true);
  };

  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false);
  };

  const handleBackToDashboard = () => {
    navigate('/admin-dashboard');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header user={user} onLogout={handleLogout} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-8 flex items-center justify-between">
          <div>
            <button
              onClick={handleBackToDashboard}
              className="text-primary hover:text-primary/80 flex items-center space-x-2 mb-4"
            >
              <span>←</span>
              <span>Back to Admin Dashboard</span>
            </button>
            <h1 className="text-3xl font-bold text-foreground">Agent Performance & Risk Analytics</h1>
            <p className="text-muted-foreground mt-2">
              Comprehensive performance evaluation and risk assessment for agents
            </p>
          </div>
          <div className="flex items-center space-x-4">
            <select
              value={selectedTimeRange}
              onChange={(e) => setSelectedTimeRange(e?.target?.value)}
              className="px-4 py-2 border border-border rounded-lg bg-card text-foreground"
            >
              <option value="24h">Last 24 Hours</option>
              <option value="7d">Last 7 Days</option>
              <option value="30d">Last 30 Days</option>
              <option value="90d">Last 90 Days</option>
              <option value="1y">Last Year</option>
            </select>
          </div>
        </div>

        {/* Agent Metrics Overview */}
        <div className="mb-8">
          <AgentMetricsOverview timeRange={selectedTimeRange} />
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
          {/* Agent Performance Table */}
          <div className="lg:col-span-2">
            <AgentPerformanceTable
              timeRange={selectedTimeRange}
              onAgentSelect={handleAgentSelect}
              selectedAgent={selectedAgent}
            />
          </div>

          {/* Risk Contribution Panel */}
          <div className="lg:col-span-1">
            <RiskContributionPanel
              selectedAgent={selectedAgent}
              timeRange={selectedTimeRange}
            />
          </div>
        </div>

        {/* All Agents List */}
        <div className="mb-8">
          <AllAgentsList onAgentClick={handleAgentClick} />
        </div>

        {/* Performance Insights */}
        <div className="mb-8">
          <PerformanceInsights
            selectedAgent={selectedAgent}
            timeRange={selectedTimeRange}
          />
        </div>
      </main>

      {/* Agent Detail Modal */}
      <AgentDetailModal
        agent={selectedAgent}
        isOpen={isDetailModalOpen}
        onClose={handleCloseDetailModal}
      />
    </div>
  );
};

export default AgentPerformanceAnalytics;